import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/shared/services/auth/auth.service';
import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';
import { SEOService } from '@app/shared/services/seo/seo.service';
import { User } from 'oidc-client';

@Component({
  selector: 'app-login-required',
  templateUrl: './login-required.component.html',
  styleUrls: ['./login-required.component.scss']
})
export class LoginRequiredComponent implements OnInit {

  private returnUrl: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private seoService: SEOService) {

    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'AUTH.LOGIN-REQUIRED.META-TITLE'
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: 'AUTH.LOGIN-REQUIRED.META-DESCRIPTION'
      }
    ]);
  }

  ngOnInit(): void {
    this.openSignInPopup();
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  openSignInPopup(): void {
    this.authService.signIn$()
      .subscribe((user: User) => {
        if (user) {
          this.router.navigateByUrl(this.returnUrl);
        }
      });
  }

}
